import { Field } from "redux-form";

import {
  GraterOrEqualZeroIntegerNumberFormat,
  Stack,
  Typography,
} from "@braintrust/braintrust-ui-components";
import { NumberField, SelectField } from "@js/forms/fields";
import { maxValue, minValue } from "@js/forms/validators";

const minDurationValidator = minValue(5);
const maxDurationValidator = maxValue(50);
const requiredWithZero = (value: unknown) => {
  const stringValue = String(value);
  if (!stringValue.trim()) {
    return "This field is required.";
  }

  return undefined;
};

export const JobInterviewSettings = () => {
  return (
    <Stack
      sx={{
        padding: 4,
        borderRadius: 4,
        backgroundColor: "var(--white)",
        border: "1px solid var(--grey-4)",
      }}
    >
      <Typography component="h1" size="large" fontWeight={400} sx={{ mb: 0.5 }}>
        Interview Settings
      </Typography>
      <Typography component="span" size="small" fontWeight={400} sx={{ mb: 2 }}>
        Set the duration of your interview.
      </Typography>
      <Field
        id="maximum-duration"
        data-testid="maximum-duration"
        name="ai_interview_max_duration_in_minutes"
        component={NumberField}
        NumberFormat={GraterOrEqualZeroIntegerNumberFormat}
        label="Maximum duration (minutes)"
        validate={[
          requiredWithZero,
          minDurationValidator,
          maxDurationValidator,
        ]}
        sx={{
          mb: 2,
          "& .MuiInputBase-input": {
            padding: "8px 16px !important",
          },
        }}
      />
      <Field
        id="retake-count"
        data-testid="retake-count"
        name="ai_interview_maximum_attempts"
        label="Interview retake limit"
        menuVariant="violet"
        component={SelectField}
        validate={[requiredWithZero]}
        MenuProps={{
          slotProps: {
            paper: {
              sx: {
                pb: 0.5,
                border: "1px solid var(--grey-5)",
                borderRadius: "8px",
                "& .MuiMenuItem-root": {
                  padding: "6px 8px",
                  mb: 0.5,
                },
              },
            },
          },
        }}
        sx={{
          minWidth: "295px",
          "& .MuiButtonBase-root": {
            mr: "12px",
          },
          "& .MuiInputBase-input": {
            padding: "8px 16px !important",
          },
        }}
        options={INTERVIEW_RETAKE_OPTIONS}
      />
    </Stack>
  );
};

export const INTERVIEW_RETAKE_OPTIONS = [
  {
    label: "Unlimited",
    value: -1,
  },
  {
    label: "No retake",
    value: 1,
  },
  {
    label: "1",
    value: 2,
  },
  {
    label: "2",
    value: 3,
  },
  {
    label: "3",
    value: 4,
  },
];
